import {twMerge} from '../../../common/twMerge';
import {Dot} from '../../atoms/Dot/Dot';
import {Text} from '../../atoms/Text/Text';
import {PcMainTabItemProps} from './PcMainTabItemProps.interface';

export function PcMainTabItem({
  isActive,
  hasDot,
  children,
  className,
  ...props
}: PcMainTabItemProps) {
  return (
    <div
      className={twMerge(
        'flex h-32pxr w-fit-content cursor-pointer select-none items-center justify-center rounded-16pxr py-7pxr px-14pxr',
        isActive
          ? 'bg-theme-solid-100'
          : 'border-1 border-solid border-theme-transparent-20 bg-transparent',
        hasDot && 'pr-20pxr',
        className
      )}
      {...props}
    >
      <div className="relative flex max-w-full">
        <Text
          className={twMerge(
            isActive
              ? 'font-small1-bold text-theme-solid-10'
              : 'font-small1 text-theme-solid-100'
          )}
        >
          {children}
        </Text>
        {hasDot && <Dot className="absolute top-0 -right-6pxr" />}
      </div>
    </div>
  );
}
